<template>
  <!-- 背景图片 -->
  <div class="bcg-png">
    <div class="content-box">
      <p style="margin-bottom: 4em">
        <img src="@assets/logo (2).png" />
      </p>
      <ul class="ul-box">
        <li v-for="(item, index) in data" :key="index" class="li-one" @click="click(item.appId, item.indexPage)">
          <a-radio :value="1"></a-radio>
          <p>
            <img :src="item.appCnName" alt />
          </p>
          <p>{{ item.appCnName }}</p>
        </li>
        <div class="fd"></div>
      </ul>

      <!-- 帮助中心 返回登陆 -->
      <p class="help-center">
        <a href="javascript:void(0)">帮助中2131心</a>
        <span>|</span>
        <a href="javascript:void(0)" @click="handleLogout">返回系统登陆</a>
      </p>
      <!-- 公告 -->
      <p class="announcement">
        Copyright@安徽安天利信工程管理股份有限公司 版权所有 皖ICP17006932号
        <span>
          <img src="@assets/trademark.png" alt />
        </span>
        皖公网安备 34010402701600
      </p>
    </div>
    <div class="fd"></div>
  </div>
</template>

<script>
import { sysInfoall } from '@/api/api'
import Vue from 'vue'
import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN, APPID } from '@/store/mutation-types'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      data: []
    }
  },
  created() {
    this.getInfos()
  },
  methods: {
    ...mapActions(['Logout']),
    getInfos() {
      const that = this
      sysInfoall(null).then((res) => {
        console.log(ACCESS_TOKEN, APPID)
        if (res.success) {
          that.data = res.result
          console.log(res.result)
        }
      })
    },
    click(appid, url) {
      let v_token = Vue.ls.get(ACCESS_TOKEN)
      Vue.ls.set(APPID, appid, 7 * 24 * 60 * 60 * 1000)
      var newUrl = url + '?token=' + v_token + '&appid=' + appid
      console.log(newUrl)
      window.open(newUrl, '_self', '', true)
    },
    handleLogout() {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要返回登录页面吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.href = '/atlxauth/'
            })
            .catch((err) => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
        },
        onCancel() {}
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
body {
  height: 100%;
}
li {
  list-style: none;
}
.fd {
  clear: both;
}
.bcg-png {
  width: 100%;
  height: 1080px;
  background: url(~@/assets/bcg-logo.png) no-repeat;
  background-size: 100% 100%;
  background-poisition: center center;
  .content-box {
    margin: 0 auto;
    position: relative;
    top: 120px;
    & > p {
      text-align: center;
    }
    .ul-box {
      text-align: center;
      li {
        width: 285px;
        height: 330px;
        border-radius: 10px;
        background: #fff;
        float: left;
        margin: 10px;
        cursor: pointer;
        position: relative;
        .checkbox {
          text-align: right;
          margin-right: 15px;
          display: none;
        }
        &:hover {
          box-shadow: 0px 2px 10px 3px rgba(55, 65, 74, 0.58);
          .checkbox {
            display: block;
          }
        }
      }
      .li-one {
        p:nth-child(2) {
          text-align: center;
          margin-top: 84px;
        }
        & > p:nth-child(3) {
          text-align: center;
          margin-top: 36px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
      }
      .li-two {
        & > p:nth-child(2) {
          text-align: center;
          margin-top: 84px;
        }
        & > p:nth-child(3) {
          text-align: center;
          margin-top: 36px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
      }
      .li-three {
        & > p:nth-child(2) {
          text-align: center;
          margin-top: 84px;
        }
        & > p:nth-child(3) {
          text-align: center;
          margin-top: 36px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
      }
      .li-four {
        & > p:nth-child(2) {
          text-align: center;
          margin-top: 84px;
        }
        & > p:nth-child(3) {
          text-align: center;
          margin-top: 36px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
  .help-center {
    margin-top: 97px;
    & > a {
      color: #666;
      font-size: 16px;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  .announcement {
    color: #999;
    font-size: 14px;
  }
}
</style>
<style lang="less">
.bcg-png {
  .ant-radio-wrapper {
    height: 30px;
    width: 30px;
    position: absolute;
    right: 0;
    bottom: 8px;
  }
  .ant-radio-inner {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    display: none;
  }
  .ant-radio-inner::after {
    height: 17px;
    width: 17px;
    background: url(~@/assets/check.png) no-repeat 100%;
  }
  li:hover .ant-radio-inner {
    display: block;
  }
}
</style>
